import React from 'react';

import Icon from './Icon';

const ContactUsPhoneIcon = (props) => {
    return (
        <Icon width='64' height='64' viewBox='0 0 64 64' {...props}>
            <path
                d='m31.78 34.941 2.606-2.604c1.98-1.978 5.342-1.978 7.167 0l4.034 4.032a2.998 2.998 0 0 1 0 4.242l-.743.742c-4.791 4.79-12.234 5.312-17.605 1.57l-1.53-1.24-13.897-14.036-6.18-6.186a8.994 8.994 0 0 1 .004-12.718L9.239 5.14a3.9 3.9 0 0 1 5.513 0l4.715 4.713a3.896 3.896 0 0 1 .004 5.507l-2.442 2.45c-.417.417-.729.92-.92 1.465l15.672 15.665z'
                stroke='#34303D'
                strokeWidth='2.5'
                fill='none'
                fillRule='evenodd'
                strokeLinejoin='round'
            />
        </Icon>
    );
};

export default ContactUsPhoneIcon;
